import { createContext, useCallback, useContext } from 'react'

export const ScrollPositionContext = createContext<{
	scrollPosition: number
	setScrollPosition: (scrollPosition: number, behavior?: ScrollBehavior) => void
}>({
	scrollPosition: 0,
	setScrollPosition: () => {},
})

export default function useScrollPositionContext() {
	const context = useContext(ScrollPositionContext)
	if (!context) {
		throw new Error(
			'useScrollPosition must be used within a ScrollPositionProvider',
		)
	}

	// TODO: This still isn't a guarantee that the scroll position will be updated.
	// We could do something fancier with a scrollend event listener in the future,
	// but this is okay for now.
	const getCurrentScrollPosition = useCallback(() => {
		return new Promise<number>((resolve) => {
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					resolve(context.scrollPosition)
				})
			})
		})
	}, [context.scrollPosition])

	return {
		...context,
		getCurrentScrollPosition,
	}
}
